import {
  InputType,
  ManifestIncidence,
  ManifestStatus,
  ManifestType,
} from "./ManifestInterface";

export enum StatusInventory {
  CLOSED = 67,
  PROCESS = 65,
  DISCARDED = 66,
}

export interface InventoryHeaderInterface {
  inventoryHeaderID?: string;
  inventoryHeaderCode?: string;
  inventoryTypeID?: number;
  buCodeSource?: string;
  observation?: string;
  inventoryOpenDate?: Date;
  inventoryClosedDate?: Date;
  inventoryOpenUser?: string;
  inventoryCloseUser?: string;
  manifestDetail?: InventoryDetailInterface[];
  totalWeight?: number;
  totalPieces?: number;
  numberOfShipments?: number;
  initialScanDate?: Date;
  lastScanDate?: Date;
  lastScanned?: string;    
  updateUser?: string;
  updateDate?: Date;
  creationUser?: string;
  creationDate?: Date;
  statusID?: StatusInventory;
  statusName?: string;
}

export interface InventoryDetailInterface {
  inventoryHeaderID?: string;
  inventoryDetailID?: string | null;
  serviceID?: number;
  serviceName?: string;
  serviceCode: string;
  buCodeSource: string;
  buCodeDestination?: string;
  locationDestinationCode: string;
  locationConsigneeID?: number;
  weightUnitID?: number;
  measureUnitTypeID?: number;
  lineSeqNumber?: number;
  difference: number;
  shipmentNumber: string;
  pieceNumber: number;
  totalPieces: number;
  heigh?: number;
  width?: number;
  lenght?: number;
  physicalWeight: number;
  dimensionalWeight?: number;
  barCode: string;
  buBase: string;
  creationUser: string;
  creationDate: string;
  updateUser?: string;
  updateDate?: string;
  statusID?: number;
  lastUpdate?: string;
  applicationID: number;
  daysCreation: number;
  incidence: ManifestIncidence;
  incidenceWarning: boolean;
  warnings: string;
  errors: string;
  inputType: InputType;
  chargedWeight?: number;
  locationOriginCode?: string;
  paymentModeName?: string;
}

export interface InventoryDetailSingleInterface {
  inventoryDetailID?: string | null;
  shipmentDetailID?: string | null;
  serviceID?: number;
  serviceCode: string;
  serviceName?: string;
  buCodeSource: string;
  locationDestinationCode: string;
  shipmentNumber: string;
  pieceNumber: number;
  totalPieces: number;
  physicalWeight: number;
  barcode?: string;
  lineSeqNumber?: number;
  difference: number;
  manifestType?: ManifestType;
  creationDate: string;
  daysCreation: number;
  incidence: ManifestIncidence;
  incidenceWarning: boolean;
  statusID?: number;
  warnings: string;
  errors: string;
  inputType: InputType;
  chargedWeight?: number;

  // Aux fields
  _date?: string;
}

export interface InventoryManifestFormValues {
  observation: string;
}

